module.exports = __webpack_public_path__ + "static/2021-03-27-09-30-18-205-fs8-fs8-295dc8f51ee7a28b48aba94a3d7037dd.png";